export default __webpack_public_path__ + "static/media/romina-vairolatti-1.f4f7e55b.webp";